import React, { useState } from 'react'
import { Button, Card, Image, Row, Spinner, Table } from 'react-bootstrap'
import { updateFileWorksAPI } from '../../../services/history-works'
import { BsFillFileEarmarkPdfFill, BsXLg } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import { getWorkTypeFileAPI } from '../../../services/recruit'
import SwalCustom from '../../../alert/swal-custom'
import { useDropzone } from 'react-dropzone'
import IconDownload from '../../../images/Action/Download.svg'
import IconView from '../../../images/pdf.svg'
import IconEdit from '../../../images/Edit.svg'
import Swal from 'sweetalert2'

function FileWorkHistoryTable({
  fnData,
  detail,
  isFile,
  keys,
  setShowEdite,
  roles,
  setDetailTable
}) {
  const profile = useSelector((state) => state.loginReducer.profile)
  const orgId = profile.org_id
  const code = profile.code
  const [isSave, setIsSave] = useState(false)
  const [filedoc, setFileDoc] = useState([])

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 8000000,
    accept: {
      'pdf/pdf': ['.pdf']
    },
    onDrop: (acceptedFiles) => {
      setFileDoc(acceptedFiles.map((file) => Object.assign(file)))
    },
    onDropRejected: () => {
      Swal.fire({
        icon: 'error',
        title: 'You can only upload 1 file & maximum size of 8 MB.',
        showConfirmButton: false,
        timer: 3000
      })
    }
  })

  const updateFileWorks = async (d) => {
    setIsSave(true)

    try {
      var c_formData = new FormData()
      c_formData.append('file', filedoc[0])
      c_formData.append('orgId', orgId)
      c_formData.append('code', code)
      c_formData.append('historyWorkId', d.id)

      const resp = await updateFileWorksAPI(c_formData)
      if (!resp) return
      if (resp?.status) {
        SwalCustom({
          title: 'Success!',
          text: 'Your Document has been attached',
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          fnData()
        })
      } else {
        Error_false(resp)
      }
      setIsSave(false)
      setFileDoc([])
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }

  const getFilesDocs = async (d) => {
    const body = {
      code,
      orgId,
      historyWorkId: d.id
    }
    const result = await getWorkTypeFileAPI(body)
    if (!result) return
    void window.open(result.result, '_blank')
  }

  const renderFilePreview = (file) => {
    if (file.type.startsWith('image')) {
      return (
        <img
          width={38}
          height={38}
          alt={file.name}
          src={URL.createObjectURL(file)}
        />
      )
    } else {
      return (
        <BsFillFileEarmarkPdfFill
          className="opacity-25 mt-2 mb-2"
          style={{
            fontSize: '2rem',
            marginLeft: '2px'
          }}
        />
      )
    }
  }
  const fileList = filedoc.map((file) => (
    <span key={file.name} className="d-flex justfy-content-center">
      <div className="w-100 ">
        <div>{renderFilePreview(file)}</div>
        <div className="my-auto ms-2">
          <p className="mb-0 small">{file.name}</p>
          <span className="font-small-2 fw-lighter">
            {' '}
            {Math.round(file.size / 100) / 10 > 1000
              ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
              : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
          </span>
        </div>
      </div>
      <div onClick={() => handleRemoveFile(file)}>
        <BsXLg fontSize={20} />
      </div>
    </span>
  ))

  const handleRemoveAllFiles = () => {
    setFileDoc([])
  }

  const handleRemoveFile = (file) => {
    const uploadedFiles = filedoc
    const filtered = uploadedFiles.filter((i) => i.name !== file.name)
    setFileDoc([...filtered])
  }
  const htmlUploadFile = (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <>
        <Image
          style={{
            width: '16px'
          }}
          className='pointer-event'
          src={IconDownload}
        />
        {/* <div className="mt-1 small text-secondary">(max 8 MB)</div> */}
      </>
    </div>
  )

  return (
    <tr key={keys} className="fw-light font-small-2 pointer-event">
      <td className="text-center">{keys + 1}</td>
      <td>{detail.company}</td>
      <td>{detail.position}</td>
      <td>{detail.duty}</td>
      <td className="text-center">{detail.from_year}</td>
      <td className="text-center">{detail.to_year}</td>
      <td>{detail.reason}</td>
      {/* <td className="text-center">
        {isFile && !filedoc.length ? (
          <Image
            className="pointer-event"
            onClick={() => {
              getFilesDocs(detail)
            }}
            style={{ width: '18px' }}
            src={IconView}
          />
        ) : (
          <div className="d-flex gap-3 justify-content-center">
          
          </div>
        )}
      </td>{' '} */}
      <td>
        <div className="text-center">
          {isFile ? (
            <>
              {filedoc.length ? (
                <div className="mt-3" style={{ width: '100%' }}>
                  <Card>{fileList}</Card>
                  {filedoc.length > 1 ? (
                    <span className="text-danger small">
                      สามารถอัปโหลดไฟล์ได้เพียง 1 ไฟล์เท่านั้น*
                    </span>
                  ) : (
                    <></>
                  )}
                  <div className="mt-2 mt-3">
                    <Button
                      variant="outline-danger"
                      disabled={isSave}
                      onClick={handleRemoveAllFiles}
                    >
                      นำออก
                    </Button>
                    <Button
                      disabled={isSave}
                      className="ms-3"
                      onClick={() => {
                        updateFileWorks(detail)
                      }}
                    >
                      {isSave ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          className="me-2"
                          aria-hidden="true"
                        />
                      ) : (
                        <BsFillFileEarmarkPdfFill className="me-2" />
                      )}
                      {isSave ? 'กำลังบันทึกไฟล์...' : 'บันทึกไฟล์'}
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="d-flex gap-3 justify-content-center ">
                  <Image
                    className="pointer-event"
                    onClick={() => {
                      getFilesDocs(detail)
                    }}
                    style={{ width: '18px' }}
                    src={IconView}
                  />
                  {htmlUploadFile}
                </div>
              )}
            </>
          ) : (
            <>
              {filedoc.length ? (
                <div className="mt-3" style={{ width: '100%' }}>
                  <Card>{fileList}</Card>
                  {filedoc.length > 1 ? (
                    <span className="text-danger small">
                      สามารถอัปโหลดไฟล์ได้เพียง 1 ไฟล์เท่านั้น*
                    </span>
                  ) : (
                    <></>
                  )}
                  <div className="mt-3">
                    <Button
                      variant="outline-danger"
                      disabled={isSave}
                      onClick={handleRemoveAllFiles}
                    >
                      นำออก
                    </Button>
                    <Button
                      disabled={isSave}
                      className="ms-3"
                      onClick={() => {
                        updateFileWorks(detail)
                      }}
                    >
                      {isSave ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          className="me-2"
                          aria-hidden="true"
                        />
                      ) : (
                        <BsFillFileEarmarkPdfFill className="me-2" />
                      )}
                      {isSave ? 'กำลังบันทึกไฟล์...' : 'บันทึกไฟล์'}
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="d-flex gap-3 justify-content-center">
                  {htmlUploadFile}
                </div>
              )}
            </>
          )}
        </div>
      </td>
      <td className="text-center">
        <Image
          src={IconEdit}
          style={{
            width: '20px'
          }}
          onClick={() => {
            // if (roles?.status_id === 1) {
            setDetailTable(detail)
            setShowEdite(true)
            // }
          }}
        />
      </td>
    </tr>
  )
}

export default FileWorkHistoryTable
